import CompositeShape from '../CompositeShape';
import Shape from '../Shape';

export default class WebGLComposition extends CompositeShape {

	public constructor (private components: Shape[]) {
		super();
	}

	public copy () {
		return new WebGLComposition(this.components.map(component => component.copy()));
	}

	/*
	 * Protected methods
	 */

	public getComponents () {
		return this.components;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/shapes/composites/WebGLComposition.ts